export default __webpack_public_path__ + "static/media/Hair_3_M_C5.d47b0638.svg";